import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export default function NotFound() {
  const location = useLocation();

  useDocumentMeta({
    title: '页面没有找到 - 爆料短剧',
    description: '你访问的页面不存在或已被移动，返回爆料短剧首页继续查看短剧更新顺序与追剧日历。',
    path: location.pathname,
    ogType: 'website',
  });

  return (
    <SiteLayout>
      <section className="relative mx-auto flex w-full max-w-content flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="font-display select-none text-[6rem] leading-none text-background-200 md:text-[10rem]">
          404
        </span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这个页面走丢了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-7 text-foreground-600">
          你要找的页面不存在，或者链接已经更新。回到首页，继续按顺序追剧吧。
        </p>
        <p className="mt-2 font-mono text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/dramas"
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-play-list-2-line" aria-hidden="true" />
            浏览剧集库
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}